import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import ReimburseComponent from "../ReimburseComponent/ReimburseComponent";
import { useLocation, useNavigate } from "react-router-dom";

const TeamReimbursements = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const passedState = location.state;
  useEffect(() => {
    dispatch(updateNavbarHeading(passedState ? passedState?.text : "Team Reimbursements"));
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [teamReimbursements, setTeamReimbursements] = useState([]);

  const columns = {
    ClaimDate: { text: "Claim Date", align: "center", visible: true },
    Name: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    AdvanceAmountBASE: {
      text: "Advance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    TXNNAME: { text: "Receipt No.", visible: false },
    TotalExpense: {
      text: "Total Expense (\u20B9)",
      align: "end",
      visible: true,
    },
    BalanceAmountBASE: {
      text: "Balance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    Status: { text: "Status", align: "center", visible: true },
    ActionByName: { text: "Action By", visible: false },
    PayrollMonth: { text: "Payroll Month", align: "center", visible: false },
  };
  const [apiStatus, SetApiStatus] = useState(undefined);


  const [originalData, setOriginalData] = useState([]);
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get('Status');

    const filteredData = originalData.filter(item => {

      const Fstatus = status
        ? item.Status?.trim()?.toLowerCase() === status?.trim()?.toLowerCase()
        : true;


      return Fstatus;
    });
    console.log("filteredData", filteredData);

    setTeamReimbursements(filteredData);
  }, [location.search, originalData]);


  const fetchTeamReimbursement = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/team-reimbursements`
      );
      console.log('response', response);
      SetApiStatus(response.status)
      if (response.status === 200) {
        const TeamData = response?.data?.data?.approveList?.map(item => ({ ...item, TotalExpense: Number(item?.TotalExpense).toFixed(2) }));
        console.log('TeamData', TeamData);
        setOriginalData(TeamData)
        setTeamReimbursements(TeamData);
      } else {
        console.error(
          "Failed to fetch Team Reimbursements. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Team Reimbursements:", error);
    }
  };





  useEffect(() => {
    fetchTeamReimbursement();
  }, []);

  const handleApprove = (id) => {
    navigate(`/team-reimbursements/approval/${id.ID}`);
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <ReimburseComponent
              data={teamReimbursements}
              columns={columns}
              itemsPerPage={10}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isSorting={true}
              showIcon1={true}
              isActionRequired={true}
              isFileDownloadRequired={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleIcon1={handleApprove}
              icons={{
                Icon1: <i className="fa fa-check"></i>,
                Icon1Text: "Approved",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamReimbursements;